export default "__VITE_PUBLIC_ASSET__71e613a7__"